// WHEN CHANGING HERE, also change in _dim.scss
export const bpMaxWidthSm = 599 // phone end
export const bpMinWidthMd = 600 // tablet start
export const bpMaxWidthMd = 1023 // tablet end
export const bpMinWidthLg = 1024 // desktop start
export const bpMaxWidthLg = 1279 // desktop end
export const bpMinWidthXl = 1280 // large desktop start

// WHEN CHANGING HERE, also change in _dim.scss
export const baseContainerSideGapSm = 16 // phone gap
export const baseContainerSideGapMd = 24 // tablet gap
export const baseContainerSideGapLg = 32 // desktop gap

// WHEN CHANGING HERE, also change in _dim.scss
export const baseContainerSm = 768
export const baseContainerMd = 1024
export const baseContainerLg = 1280

export const baseContainerWidth = {
  small: baseContainerSm,
  medium: baseContainerMd,
  large: baseContainerLg,
}
